import { restaurantInfo } from '@/mocks/restaurantData';

const infoCards = [
  {
    icon: 'ri-calendar-check-line',
    title: '営業時間',
    details: [
      { label: 'Lunch', value: restaurantInfo.businessHours.lunch },
      { label: 'Dinner', value: restaurantInfo.businessHours.dinner },
    ],
  },
  {
    icon: 'ri-calendar-close-line',
    title: '定休日',
    details: [
      { label: '', value: restaurantInfo.holidays },
    ],
  },
  {
    icon: 'ri-group-line',
    title: '座席',
    details: [
      { label: '総座席数', value: `${restaurantInfo.seats}席` },
      { label: '個室', value: restaurantInfo.privateRoom },
    ],
  },
  {
    icon: 'ri-phone-line',
    title: 'お電話',
    details: [
      { label: 'TEL', value: restaurantInfo.phone },
      { label: 'Mail', value: restaurantInfo.email },
    ],
  },
];

export default function InfoSection() {
  return (
    <section id="info" className="py-24 md:py-32 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16 reveal">
        <div className="inline-flex items-center gap-2 text-primary-400 font-script text-5xl">
        &mdash; Information &mdash;
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">
            ご来店の際のご案内
          </h2>
          <p className="text-foreground-400 text-sm md:text-base">
            お気軽にお問い合わせください
          </p>
        </div>

        <div className="reveal-stagger">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {infoCards.map((card) => (
              <div
                key={card.title}
                className="bg-background-50 rounded-2xl p-6 md:p-7 text-center group hover:bg-primary-500/15 transition-all duration-500 cursor-default border border-foreground-100/10"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl bg-accent-500/10 flex items-center justify-center group-hover:bg-accent-500/20 transition-colors duration-500">
                  <i className={`${card.icon} text-2xl text-accent-400 group-hover:text-accent-300 transition-colors duration-500`}></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors duration-500 mb-4">
                  {card.title}
                </h3>
                <div className="space-y-1.5">
                  {card.details.map((detail) => (
                    <p
                      key={detail.label}
                      className="text-foreground-400 text-sm transition-colors duration-500"
                    >
                      {detail.label && (
                        <span className="font-semibold text-foreground-500 transition-colors duration-500">
                          {detail.label}：
                        </span>
                      )}
                      {detail.value}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}